function initImageCircles(viewport) {
  if (viewport.dataset.circlesInit) return;
  viewport.dataset.circlesInit = '1';

  const track = viewport.querySelector('.image-circles');
  if (!track) return;

  const realCount = Number(track.dataset.realCount) || 0;
  const isLoop = track.classList.contains('image-circles--loop') && realCount > 1;
  if (!isLoop) return;

  const rtl = getComputedStyle(track).direction === 'rtl';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const firstSet = Array.from(track.children).slice(0, realCount);

  let period = 0;
  let x = 0;
  let velocity = 0;
  let rafId = null;
  let lastFrame = 0;

  // Focus and the theme editor may native-scroll the clipped viewport;
  // position is transform-driven, so undo any real scroll.
  viewport.addEventListener('scroll', () => viewport.scrollTo(0, 0));

  function wrapX() {
    let m = x % period;
    if (m < 0) m += period;
    return m;
  }

  function render() {
    if (!period) return;
    const tx = rtl ? wrapX() : wrapX() - period;
    track.style.transform = `translate3d(${tx}px, 0, 0)`;
  }

  function setup() {
    period = Math.abs(track.children[realCount].offsetLeft - track.children[0].offsetLeft);
    if (!period) return;
    // The strip must stay wider than the viewport by at least one full set
    // for the wrap to be invisible; clone extra sets on wide screens.
    let guard = 0;
    while (track.scrollWidth < viewport.clientWidth + period * 2 && guard < 10) {
      firstSet.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.removeAttribute('id');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('button, a').forEach((el) => el.setAttribute('tabindex', '-1'));
        track.appendChild(clone);
      });
      guard += 1;
    }
    render();
  }

  setup();
  window.addEventListener('load', setup, { once: true });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setup, 150);
  });

  function stopMomentum() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;
  }

  function startMomentum() {
    if (reducedMotion || Math.abs(velocity) < 0.05) return;
    lastFrame = performance.now();
    const step = (now) => {
      const dt = Math.min(now - lastFrame, 64) || 1;
      lastFrame = now;
      x += velocity * dt;
      velocity *= Math.exp(-dt / 500);
      render();
      rafId = Math.abs(velocity) > 0.005 ? requestAnimationFrame(step) : null;
    };
    rafId = requestAnimationFrame(step);
  }

  let pointerId = null;
  let startX = 0;
  let lastX = 0;
  let lastMoveTime = 0;
  let dragged = false;

  viewport.addEventListener('pointerdown', (event) => {
    if (!event.isPrimary) return;
    pointerId = event.pointerId;
    startX = lastX = event.clientX;
    lastMoveTime = performance.now();
    dragged = false;
    velocity = 0;
    stopMomentum();
  });

  viewport.addEventListener('pointermove', (event) => {
    if (event.pointerId !== pointerId) return;
    const now = performance.now();
    const dx = event.clientX - lastX;
    lastX = event.clientX;
    if (!dragged && Math.abs(event.clientX - startX) > 6) {
      dragged = true;
      if (viewport.setPointerCapture) viewport.setPointerCapture(event.pointerId);
    }
    if (!dragged) return;
    const dt = Math.max(now - lastMoveTime, 1);
    lastMoveTime = now;
    x += dx;
    velocity = 0.8 * velocity + 0.2 * (dx / dt);
    render();
  });

  function endDrag(event) {
    if (event.pointerId !== pointerId) return;
    pointerId = null;
    // A pause before lifting the finger means "stop here" — no fling.
    if (performance.now() - lastMoveTime > 80) velocity = 0;
    if (dragged) startMomentum();
  }

  viewport.addEventListener('pointerup', endDrag);
  viewport.addEventListener('pointercancel', endDrag);

  viewport.addEventListener(
    'click',
    (event) => {
      if (dragged) {
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      }
    },
    true
  );

  viewport.addEventListener('dragstart', (event) => event.preventDefault());

  viewport.addEventListener(
    'wheel',
    (event) => {
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
      event.preventDefault();
      stopMomentum();
      x -= event.deltaX;
      render();
    },
    { passive: false }
  );

  track.addEventListener('focusin', (event) => {
    const rect = event.target.getBoundingClientRect();
    const view = viewport.getBoundingClientRect();
    if (rect.left < view.left) x += view.left - rect.left + 16;
    else if (rect.right > view.right) x -= rect.right - view.right + 16;
    render();
  });
}

document.querySelectorAll('[data-image-circles]').forEach(initImageCircles);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-image-circles]').forEach(initImageCircles);
});
